//firebase
import { initializeApp } from 'firebase/app';
import { getFirestore, doc, setDoc, onSnapshot } from "firebase/firestore";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

const firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG);

let _firebaseIsLogged = false;
let _listenerFirebaseDates = {};
const suffix = process.env.REACT_APP_FIREBASE_SUFFIX
export const firebase = initializeApp(firebaseConfig);
export const firestore = getFirestore(firebase);
export const signInFirebase = async () => {
  try {
    const auth = getAuth(firebase);
    const userCredential = await signInWithEmailAndPassword(
        auth, 
        process.env.REACT_APP_FIREBASE_EMAIL, 
        process.env.REACT_APP_FIREBASE_PASS
    );
    _firebaseIsLogged = true;
    return userCredential.user;
  } catch (error) {
    const errorCode = error.code;
    const errorMessage = error.message;
    console.log(errorCode, errorMessage);
    return null;
  }
};
export const firebaseIsLogged = () => _firebaseIsLogged;

export const notifyGaspFirebase = async (page, data = {}, dateFieldName = 'updated_at') => {
  try {
    if (!firebaseIsLogged()) {
      await signInFirebase();
    }
    const pageName = `gasp_${page}_${suffix}`;
    const docRef = doc(firestore, pageName, 'allUsers');
    const now = (new Date()).toISOString();
    _listenerFirebaseDates[pageName] = now;
    await setDoc(docRef, { [dateFieldName]: now, ...data });
  } catch (e) {
    console.log(e);
  }
};

export const listenerGaspFirebase = async (page, onSnapshotChange, dateFieldName = 'updated_at') => {
  try {
    if (!firebaseIsLogged()) {
      await signInFirebase();
    }
    const pageName = `gasp_${page}_${suffix}`;
    _listenerFirebaseDates[pageName] = (new Date()).toISOString();
    const docRef = doc(firestore, pageName, 'allUsers');
    return onSnapshot(docRef, (change) => {
      const docData = change.data();
      if (docData) {
        const date_at = docData[dateFieldName];
        if (date_at > _listenerFirebaseDates[pageName]) {
          onSnapshotChange(docData);
        }
      }
    }); 
  } catch (e) {
    console.log(e);
    return null;
  }
}

export const notifyPartnerFirebase = async (page, user, data = {}, dateFieldName = 'updated_at') => {
  try {
    if (!firebaseIsLogged()) {
      await signInFirebase();
    }
    const pageName = `partner_${page}_${suffix}`;
    const docRef = doc(firestore, pageName, user);
    const now = (new Date()).toISOString();
    _listenerFirebaseDates[pageName] = now;
    await setDoc(docRef, { [dateFieldName]: now, ...data });
  } catch (e) {
    console.log(e);
  }
};

export const listenerPartnerFirebase = async (page, user, onSnapshotChange, dateFieldName = 'updated_at') => {
  try {
    if (!firebaseIsLogged()) {
      await signInFirebase();
    }
    const pageName = `partner_${page}_${suffix}`;
    _listenerFirebaseDates[pageName] = (new Date()).toISOString();
    const docRef = doc(firestore, pageName, user);
    return onSnapshot(docRef, (change) => {
      const docData = change.data();
      if (docData) {
        const date_at = docData[dateFieldName];
        if (date_at > _listenerFirebaseDates[pageName]) {
          onSnapshotChange(docData);
        }
      }
    }); 
  } catch (e) {
    console.log(e);
    return null;
  }
}